import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import useApi from "../hooks/useApi";
import useSnack from "../hooks/useSnack";
import SnackAlert from "../components/SnackAlert";

// C4: encuesta de satisfacción. Si hay una pregunta activa que el usuario no
// ha respondido, se muestra un modal al entrar. "Ahora no" la pospone durante
// la sesión del navegador (vuelve a aparecer en la próxima visita).
export default function EncuestaBanner() {
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [encuesta, setEncuesta] = useState(null);
  const [respuesta, setRespuesta] = useState("");
  const [abierta, setAbierta] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("token")) return;
    try {
      const usuario = JSON.parse(localStorage.getItem("user") || "null");
      if (usuario?.role === "admin") return; // la encuesta es para usuarios finales
    } catch {}
    loadApi("user/encuesta", true, "get")
      .then((res) => {
        const pendiente = res.data.encuesta;
        if (
          pendiente &&
          sessionStorage.getItem("encuesta_pospuesta") !== String(pendiente.id)
        ) {
          setEncuesta(pendiente);
          setAbierta(true);
        }
      })
      .catch(() => {});
  }, []);

  if (!encuesta) return null;

  const posponer = () => {
    sessionStorage.setItem("encuesta_pospuesta", String(encuesta.id));
    setAbierta(false);
  };

  const enviar = () => {
    loadApi("user/encuesta", true, "post", {
      encuestaId: encuesta.id,
      respuesta: respuesta.trim(),
    })
      .then((res) => {
        showSnack(res.data.message);
        setAbierta(false);
        setEncuesta(null);
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  return (
    <>
      <Dialog open={abierta} onClose={posponer} fullWidth maxWidth="sm">
        <DialogTitle sx={{ color: "#F27224", fontWeight: 700 }}>
          Tu opinión nos importa
        </DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Typography variant="subtitle1">{encuesta.pregunta}</Typography>
            <TextField
              multiline
              rows={4}
              value={respuesta}
              onChange={(e) => setRespuesta(e.target.value)}
              placeholder="Escribe tu respuesta..."
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button variant="text" onClick={posponer}>
            Ahora no
          </Button>
          <LoadingButton
            loading={loadingApi.includes("post__user/encuesta")}
            onClick={enviar}
            disabled={!respuesta.trim()}
            sx={{
              bgcolor: "#F27224",
              color: "#fff",
              "&:hover": { bgcolor: "#d9611a" },
              textTransform: "none",
            }}
          >
            Enviar respuesta
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}
